import { DefaultRuleset } from './ruleset';


export const validatePasswordFormat = (password, ruleset = DefaultRuleset) => {
    const violations = [];
    const ruleStates = {};

    let success = true;

    for (const rule of ruleset) {
        const ruleSuccess = rule.passes(password);

        ruleStates[rule.name] = ruleSuccess;
        if (!ruleSuccess) {
            violations.push(rule.getViolation());
            success = false;
        }
    }

    return {
        success,
        rules: ruleStates,
        violations
    };
};
